const createRequestForSaveUserData = (values: any) => {
  const { sex, heightValue, heightUnit, dateOfBirth } = values;

  const variables = {
    isFemale: sex === 'female' ? true : false,
    birthDate: dateOfBirth,
    height: heightValue ? { value: heightValue, unit: heightUnit } : null,
    startDate: new Date().toISOString().slice(0, 10),
  };

  return variables;
};

export default createRequestForSaveUserData;
